import type { RuntimeConfig } from '@nuxt/schema'

let config: RuntimeConfig
export function getConfig() {
  if (!config) {
    config = useRuntimeConfig()
  }
  return config
}

export type AppEnv = 'development' | 'production' | 'staging' | 'testing' | 'testing2'

export function getEnvironment(): AppEnv {
  return getConfig().public.APP_ENV as AppEnv
}

export function isProduction() {
  return getEnvironment() === 'production'
}

export function getClientDomain() {
  const { hostname } = new URL(getConfig().public.BACKEND_URL)
  const dot = hostname.indexOf('.')
  return dot !== -1 ? hostname.slice(dot) : hostname
}

export function isDevelopment() {
  return process.env.NODE_ENV === 'development'
}

export { getApiEnvironmentTone } from '@utils/devEnvironment'
